module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ashou17-fda73bd589ff9f94853dfcc0641e63db.jpg";